import { CheckableTag, TagBase } from "./Tag";

/** `Tag.CheckableTag` wie bei Antd; eigene Datei wegen Fast Refresh. */
export const Tag = Object.assign(TagBase, { CheckableTag });
